<template>
    <div class="home">
        <b-container fluid>
            <b-row>
                <b-col>
                    <h1>License & Application History</h1>
                </b-col>
            </b-row>

            <div class="card">
                <div class="card-header">License</div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="4">
                            <span class="font-weight-bold">Number: </span>{{license.number}}
                        </b-col>
                        <b-col cols="4">
                            <span class="font-weight-bold">Category: </span>{{catLabel(license.licenseSubCategory)}}
                        </b-col>
                        <b-col cols="4">
                            <span class="font-weight-bold">Effective Date: </span>{{license.effectiveDate}}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4">
                            <span class="font-weight-bold">Status: </span>{{license.status}}
                        </b-col>
                        <b-col cols="4">
                            <span class="font-weight-bold">Type: </span>{{license.licenseType ? license.licenseType.description : ''}}
                        </b-col>
                        <b-col cols="4">
                            <span class="font-weight-bold">Expiry Date: </span>{{license.expirationDate}}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4">
                            <span class="font-weight-bold">Date of Birth: </span>{{license.dateOfBirth}}
                        </b-col>
                        <b-col cols="4">
                            <span class="font-weight-bold">SSN: </span>
                            <span v-if="applications.length > 0">{{applications[0].license.socialSecurityNumber}}</span>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div class="card">
                <div class="card-header">Applications</div>
                <div class="card-body">
                    <b-row role="alert">
                        <b-col>
                            <div class="sr-only hidden" v-if="isLoading">Loading, Please Wait...</div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-table hover small show-empty class="sr-caption"
                                     aria-live="polite"
                                     responsive="true"
                                     :fields="fields"
                                     :items="applications"
                                     :busy="isLoading"
                                     label-sort-asc=""
                                     label-sort-desc=""
                                     caption="Application History table.  To sort the data in this table by a specific column,
                                        go to the appropriate column header cell and use enter to sort the data ascending.
                                        Use enter again to sort descending.">
                                <template v-slot:no-data>
                                    No Applications Found.
                                </template>
                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                                <template v-slot:cell(notes)="row">
                                    <p v-for="(note, index) in row.item.notes" :key="note.id">
                                        {{note.noteByName}} {{note.noteDate}} - {{note.note}}
                                    </p>
                                </template>
                                <template v-slot:cell(formattedWorkDates)="row">
                                    <p class="mt-0 mb-1" v-for="(date, index) in row.item.workDates" :key="index">
                                        {{momentFormat(date.startDate)}} - {{momentFormat(date.endDate)}}
                                    </p>
                                </template>
                                <template v-slot:cell(actions)="row">
                                    <b-button size="sm" @click="launchReadonly(row.item)"
                                              variant="primary"
                                              class="mr-1" >
                                        view details
                                    </b-button>
                                </template>
                                <template slot="empty" slot-scope="scope">
                                    No Applications Found.
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </div>
            </div>

        </b-container>

    </div>
</template>

<script>
    import axios from 'axios'
    import { required, maxLength } from 'vuelidate/lib/validators'
    import moment from 'moment'

    export default {
        data: () => ({
            id: '',
            applications: [],
            license: '',
            fields:  [
                {key: "lastName", label: "Last Name", sortable: true},
                {key: "firstName", label: "First Name", sortable: true},
                {key: "middleName", label: "Middle Name", sortable: true},
                {key: "emailAddress", label: "Email", sortable: true},
                {key: "preferredPhone", label: "Preferred Phone", sortable: true},
                {key: 'applicationStatus', label: 'Application Status', sortable: true},
                {key: 'paymentStatus', label: 'Payment Status', sortable: true},
            ],
            isLoading: true
        }),
        methods: {
            findApplications() {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/history/${this.id}`)
                    .then(response => {
                        this.applications = response.data
                        this.isLoading = false
                    })
            },
            getLicense(id) {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/license/${this.id}`)
                    .then(response => {
                        this.license = response.data
                    })
            },
            catLabel(label) {
                if (label === 'FULL') {
                    return "Full Technician Application"
                }
                if (label === 'GUEST') {
                    return "Guest Technician Application"
                }
                if (label === 'TEMPORARY') {
                    return "Temporary Technician Application"
                }
                return ""
            },
            launchReadonly(item) {
                if (this.hasRole('ie-staff')) {
                    this.$router.push({ name: 'readonlyScreen', params: { id: item.applicationId } })
                } else if (this.hasRole('mdh-admin') || this.hasRole('mdh-staff') || this.hasRole('readonly')) {
                    if (item.applicationType.code === 'R') {
                        this.$router.push({ name: 'readonlyRenewal', params: { id: item.applicationId } })
                    } else {
                        this.$router.push({ name: 'readonlyInitial', params: { id: item.applicationId } })
                    }
                } else if (this.hasRole('finance-staff')) {
                    this.$router.push({ name: 'finance-screen', params: { id: item.applicationId } })
                }
            },
            hasRole(roles) {
                if (this.$keycloak) {
                    return this.$keycloak.hasResourceRole(roles)
                } else {
                    return false;
                }
            },
            momentFormat(date) {
                return moment(date).format("MM/DD/YYYY")
            },
        },
        created() {
            this.id = this.$route.params.id;
            this.getLicense(this.id);
            this.findApplications();
            document.title = "License & Application History - Body Art"
            if (this.$keycloak.authenticated && (this.$keycloak.hasResourceRole('mdh-staff') || this.$keycloak.hasResourceRole('ie-staff')
                || this.$keycloak.hasResourceRole('mdh-admin') || this.$keycloak.hasResourceRole('mnit-admin')
                || this.$keycloak.hasResourceRole('readonly') || this.$keycloak.hasResourceRole('finance-staff'))) {
                this.fields.push({key: 'notes', label: 'Notes'},{key: 'actions', label: 'Actions', sortable: true},)
            } else {
                this.fields.push(
                    {key: "issuedDate", label: "Effective Date", sortable: true},
                    {key: "expirationDate", label: "Expiration Date", sortable: true},
                    {key: "formattedWorkDates", label: "Work Dates", sortable: true},)
            }
        },
    }
</script>

<style>
</style>